<template>
  <div>
    <div class="cmd-group">
      <div class="form-group">
        <b>{{
          announcement
            ? "Numar PV de evaluare a ofertelor"
            : assignmentNumberTitle[assignmentType]
        }}</b>
        <input type="text" class="vInput" v-model="cmd.assignmentNumber" />
      </div>
      <div class="form-group">
        <b>{{
          announcement
            ? "Data PV de evaluare a ofertelor"
            : assignmentDateTitle[assignmentType]
        }}</b>
        <date-picker
          v-model="cmd.assignmentDate"
          type="date"
          format="DD-MM-YYYY"
          valueType="date"
          popup-class="bigger-index"
          :disabled-date="valueDisableDate"
        />
      </div>
    </div>
    <div class="cmd-group">
      <div class="form-group noMB">
        <div>
          <b>CUI furnizor</b>
        </div>
        <div class="RForm">
          <input
            type="text"
            class="vInput"
            inputmode="numeric"
            v-model="cmd.institutionProviderCui"
            @input="
              cmd.institutionProviderCui = cmd.institutionProviderCui.replace(
                /\D/g,
                ''
              )
            "
            :disabled="verbalProcess ? true : false"
            :class="{ 'form-disabled': verbalProcess ? true : false }"
          />
          <i @click="getCuiFullInfo" class="fas fa-search"></i>
        </div>
      </div>
      <div class="form-group">
        <b>Nume furnizor</b>
        <input
          type="text"
          class="vInput form-disabled"
          v-model="cmd.institutionProviderName"
          :disabled="true"
        />
      </div>
    </div>

    <div class="cmd-group" v-if="!disabledDepartment">
      <div class="form-group">
        <b>Valoarea totală inițială, fără TVA</b>
        <CustomNumberInput
          v-model="cmd.initialTotalValueWithoutTva"
          :disabled="verbalProcess || announcement ? true : false"
        ></CustomNumberInput>
      </div>
      <div class="form-group">
        <b>Valoarea totală inițială, cu TVA</b>
        <CustomNumberInput
          v-model="cmd.initialTotalValueWithTva"
          :disabled="verbalProcess || announcement ? true : false"
        ></CustomNumberInput>
      </div>
    </div>

    <div class="cmd-group">
      <div class="form-group">
        <b>Valoarea totală efectivă, fără TVA</b>

        <CustomNumberInput
          v-model="cmd.totalValueWithoutTva"
          :disabled="verbalProcess ? true : false"
        ></CustomNumberInput>
      </div>
      <div class="form-group">
        <b>Cotă TVA</b>
        <input
          min="0"
          max="100"
          type="text"
          class="vInput procent"
          :class="{ 'form-disabled': verbalProcess ? true : false }"
          v-model="cmd.tvaValue"
          @input="updateTva"
          :disabled="verbalProcess ? true : false"
        />
      </div>
    </div>

    <div class="cmd-group">
      <div class="form-group">
        <b>Criteriul de atribuire</b>
        <v-select
          v-model="cmd.attributionCriteria"
          :options="[
            'Preţul cel mai scăzut',
            'Costul cel mai scăzut',
            'Cel mai bun raport calitate-preţ',
            'Cel mai bun raport calitate-cost',
          ]"
          :disabled="verbalProcess || announcement ? true : false"
        >
        </v-select>
      </div>

      <div class="form-group">
        <b>Valoare totală, cu TVA</b>
        <CustomNumberInput
          v-model="cmd.totalValueWithTva"
          :disabled="true"
        ></CustomNumberInput>
      </div>
    </div>

    <div class="cmd-group">
      <div class="form-group">
        <b>Departamentele achiziției</b>
        <v-select
          v-model="cmd.departments"
          label="name"
          :options="departments"
          :appendToBody="true"
          :multiple="true"
          :disabled="disabledDepartment"
        >
        </v-select>
      </div>
    </div>
    <div class="cmd-group">
      <div class="form-group">
        <b>Adresa de livrare</b>
        <textarea
          v-model="cmd.receiverAddress"
          class="vInput"
          rows="6"
        ></textarea>
      </div>
    </div>

    <div
      v-if="assignmentType === AssignmentDocumentType.ComandaFermaTip1"
      class="cmd-group"
    >
      <div class="form-group">
        <files-manager
          v-model="cmd.documents"
          :signDeleted="true"
          :convertToPdf="true"
          :allowExtensions="['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']"
          @converting="onConverting"
        >
          <template v-if="cmd.documents?.length > 0" v-slot:label-right>
            <span style="cursor: pointer" @click="viewEditingNeedFiles()">
              <i class="fas fa-eye"></i>
            </span>
          </template>
        </files-manager>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "@/mixins/DatePicker.js";
import CustomNumberInput from "@/components/CustomNumberInput";
import {
  INSTITUTION_PROVIDERS,
  DEPARTMENT,
  ASSIGNMENT_DOCUMENTS,
} from "../api";
import createLegalEntityMixin from "../mixins/createLegalEntityMixin";
import { AssignmentDocumentType } from "@/common/types/command.type.js";
import FilesAgent from "@/components/FilesAgent";
import { mapMutations } from "vuex";
import { OfferEvaluationResult } from "@/common/types/offer-evaluation-result.type";

export default {
  mixins: [DatePicker, createLegalEntityMixin],
  components: { CustomNumberInput, "files-manager": FilesAgent },

  props: {
    initial: {
      type: Object,
      default: () => null,
    },
    assignmentType: {
      type: String,
      required: true,
    },
    verbalProcess: { type: Object, default: () => null },
    announcement: { type: Object, default: () => null },
    needReferences: {
      type: Array | String,
      required: false,
    },
  },

  data() {
    return {
      AssignmentDocumentType,
      departments: [],
      filesConverting: false,
      cmd: {
        assignmentNumber: "",
        assignmentDate: "",
        institutionProviderCui: "",
        institutionProviderName: "",
        totalValueWithoutTva: "",
        tvaValue: "",
        totalValueWithTva: "",
        attributionCriteria: "",
        departments: [],
        initialTotalValueWithoutTva: "",
        initialTotalValueWithTva: "",
        receiverAddress: "",
        documents: [],
      },
    };
  },

  watch: {
    cmd: {
      handler(val) {
        val.totalValueWithTva = this.exactRound(
          this.prepareTva(
            val.totalValueWithoutTva,
            this.removePercentage(val.tvaValue)
          )
        );

        this.$emit("input", {
          ...val,
          tvaValue: this.removePercentage(val.tvaValue),
          filesConverting: this.filesConverting,
        });
      },
      deep: true,
      immediate: true,
    },
    filesConverting(val) {
      this.$emit("input", {
        ...this.cmd,
        tvaValue: this.removePercentage(this.cmd.tvaValue),
        filesConverting: val,
      });
    },
    deep: true,
    immediate: true,
  },

  computed: {
    disabledDepartment() {
      return (
        (Array.isArray(this.needReferences) &&
          this.needReferences.length > 0) ||
        this.needReferences === "all" ||
        (this.initial && this.initial.numberOfReferences > 0) ||
        this.announcement != null ||
        this.verbalProcess != null
      );
    },
  },

  methods: {
    ...mapMutations({
      addWindow: "addWindow",
    }),
    onConverting(val) {
      this.filesConverting = val;
      this.$emit("converting", val);
    },
    getCuiFullInfo() {
      const error = (msg) => {
        this.$toastr.e(msg || "Furnizorul nu a fost gasit.");
        this.cmd.institutionProviderName = "";
        this.setLoad(false);
      };

      this.setLoad(true);

      INSTITUTION_PROVIDERS.getCuiFullInfo(this.cmd.institutionProviderCui)
        .then((res) => {
          if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
            if (!res.data.conectx) {
              this.$toastr.e("Persoana juridică nu a fost găsită.");
              this.askCreateLegalEntity(res.data, () => {
                this.cmd.institutionProviderName = res.data.name;
              });
            } else {
              this.cmd.institutionProviderName = res.data.name;
            }
            this.setLoad(false);
          } else {
            error(res?.data?.response || null);
          }
        })
        .catch(error);
    },

    updateTva(event) {
      if (event.inputType == "deleteContentBackward" && this.cmd.tvaValue) {
        this.cmd.tvaValue = this.cmd.tvaValue.slice(0, -1);
        this.cmd.tvaValue += "%";
        return;
      }

      event.target.value = this.removePercentage(event.target.value);

      this.cmd.tvaValue = event.target.value.match(/^\d+\.?\d{0,2}$/);

      if (this.cmd.tvaValue) {
        this.cmd.tvaValue += "%";
      }
    },

    removePercentage(val) {
      if (!val) return "";
      return val.replace("%", "");
    },

    initCmd() {
      if (this.verbalProcess) {
        let winner = this.verbalProcess.verbalProcessInstitutionProvider.find(
          (el) => el.evaluationResult === OfferEvaluationResult.WINNER
        );

        if (!winner) {
          this.verbalProcess.verbalProcessInstitutionProvider.sort(
            (a, b) => a.totalValueWithoutTva - b.totalValueWithoutTva
          );

          winner = this.verbalProcess.verbalProcessInstitutionProvider[0];
        }

        this.cmd = {
          assignmentNumber: "",
          assignmentDate: "",
          institutionProviderCui: winner.institutionProvider.cui,
          institutionProviderName: winner.institutionProvider.name,
          totalValueWithoutTva: winner.totalValueWithoutTva,
          tvaValue: winner.tvaValue + "%",
          totalValueWithTva: winner.totalValueWithTva,
          attributionCriteria: this.verbalProcess.attributionCriteria,
        };
      } else if (this.announcement) {
        this.cmd.attributionCriteria = this.announcement.attributionCriteria;
      }
    },
    valueDisableDate(date) {
      if (!this.announcement) return false;

      const maxDatePickerDate = new Date();

      if (maxDatePickerDate <= date) {
        return true;
      }

      return false;
    },

    viewEditingNeedFiles() {
      const localFiles = {};
      const fileNames = {};

      const fileList = this.cmd.documents
        .filter((e) => !e.deleted)
        .map((e) => {
          if (e.keyFilename) {
            fileNames[e.keyFilename] = e.file.name;
            return e.keyFilename;
          }
          localFiles[e.file.name] = e.file;
          fileNames[e.file.name] = e.file.name;
          return e.file.name;
        });

      this.addWindow({
        itemId: this.cmd.id,
        fileList,
        localFiles,
        fileNames,
        canDelete: false,
        modal: 13,
        searchModuleApi: ASSIGNMENT_DOCUMENTS.getDocument,
      });
    },
  },

  created() {
    if (this.initial) {
      this.cmd = {
        ...this.initial,
        assignmentDate: new Date(this.initial.assignmentDate),
        tvaValue: this.initial.tvaValue + "%",
        institutionProviderName: this.initial.institutionProvider.name,
        institutionProviderCui: this.initial.institutionProvider.cui,
        documents: (this.initial.documents || []).map((el, i) => ({
          key: i,
          file: { name: el.name },
          keyFilename: el.key,
          originalName: el.name,
        })),
      };
    }

    this.initCmd();

    if (
      (Array.isArray(this.needReferences) &&
        this.needReferences.length === 0) ||
      (this.initial && this.initial.numberOfReferences === 0)
    ) {
      DEPARTMENT().then((res) => {
        if (this.checkHttpStatusCode(res?.meta?.HttpStatusCode)) {
          this.departments = res.data.result;
        }
      });
    } else if (
      Array.isArray(this.needReferences) &&
      this.needReferences.length > 0
    ) {
      this.departments = [
        ...new Map(
          this.needReferences.map((el) => [el.department.id, el.department])
        ).values(),
      ];
      this.cmd.departments = this.departments;
    } else if (this.announcement) {
      this.departments = this.announcement.departments;
      this.cmd.departments = this.announcement.departments;
    } else if (this.verbalProcess) {
      this.departments = this.verbalProcess.departments;
      this.cmd.departments = this.verbalProcess.departments;
    }

    if (
      this.assignmentType === AssignmentDocumentType.ComandaFermaTip3 ||
      this.assignmentType === AssignmentDocumentType.ContractTip3 ||
      this.institutionProviderCui
    ) {
      this.cmd.institutionProviderName = "";
      this.getCuiFullInfo();
    }
  },
};
</script>
<style lang="scss">
.cmd-group {
  display: flex;
  gap: 5px;
  .form-group {
    flex: 1;
  }
}
</style>
